/**
 * Format date to DD/MM/YYYY HH:mm:ss format
 * @param {string|Date} dateString - Date string or Date object
 * @returns {string} Formatted date string in DD/MM/YYYY HH:mm:ss format
 */
export const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  
  try {
    const date = new Date(dateString);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return 'N/A';
    }
    
    // Format: DD/MM/YYYY HH:mm:ss
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  } catch (error) {
    return 'N/A';
  }
};

/**
 * Format timestamp with relative time for recent dates, full date for older ones
 * @param {string|Date} timestamp - Timestamp string or Date object
 * @returns {string} Formatted timestamp
 */
export const formatTimestamp = (timestamp) => {
  if (!timestamp) return 'N/A';
  
  try {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    
    // For very recent dates (< 24 hours), show relative time
    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins} min ago`;
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
    
    // For older dates, show full date/time in DD/MM/YYYY HH:mm:ss format
    return formatDateTime(timestamp);
  } catch (error) {
    return 'N/A';
  }
};

